const ANONYMOUS_ID_MIN = 10000;
const ANONYMOUS_ID_MAX = 99999;

/**
 * Generates a random anonymous identifier for PUI requests.
 * Format: VALUED-CLIENT-XXXXX where XXXXX is a 5-digit number (10000-99999)
 *
 * @returns A unique anonymous client identifier
 */
export function generateAnonymousIdentifier(): string {
  const randomNum =
    Math.floor(Math.random() * (ANONYMOUS_ID_MAX - ANONYMOUS_ID_MIN + 1)) + ANONYMOUS_ID_MIN;
  return `VALUED-CLIENT-${randomNum}`;
}
